exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.bg-thank[data-v-285aaf31] {\n  height: 600px;\n  background-image: url(\"/static/img/bigCleaningNew/THANK.png\");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n}\ndiv.box-message[data-v-285aaf31] {\n  font-size: 24px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-285aaf31","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/information/ThankUsingServiceBigCleaning.vue
// module id = 1488
// module chunks = 0